// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-oc-wrapper {
  height: 290px;
}

@media (min-width: 1366px) {
  .report-oc-wrapper {
    height: 400px;
  }
}
@media (min-width: 1920px) {
  .report-oc-wrapper {
    height: 520px;
  }
}`, "",{"version":3,"sources":["webpack://./../report/src/components/UniversalReport/ReportOffcanvasJob/DynamicTableWrapper.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI;IACI,aAAA;EACN;AACF;AAEA;EACI;IACI,aAAA;EAAN;AACF","sourcesContent":[".report-oc-wrapper {\n    height: 290px;\n}\n\n@media (min-width: 1366px) { \n    .report-oc-wrapper {\n        height: 400px;\n    }\n}\n\n@media (min-width: 1920px) { \n    .report-oc-wrapper {\n        height: 520px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
